import Form from "./Form";
import { routes, apiRoutes } from "../routes/routes";

function Login() {
    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="card border-0 rounded-4 shadow-lg p-4 w-100">
                <Form route={ apiRoutes.get_token } method="login" />
                <div className="mt-5">
                    <a href={routes.register.path}>Register</a>
                </div>
            </div>
        </div>
    )
}

export default Login